import { logger } from 'lib/logger';
import { useSelector } from 'react-redux';
import { summerPromo2026, summerPromo2026Anonym } from 'reactApp/appHelpers/featuresHelpers/features/summerPromo2026';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import { sendXray } from 'reactApp/utils/ga';
import { captureException } from 'reactApp/utils/tracer';

export const SUMMER_PROMO_2026_ENABLED_QUERY_PARAM = 'summer-promo-2026-enabled';

export const checkSummerPromo2026ForceQuery = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);

        return !!urlParams.get(SUMMER_PROMO_2026_ENABLED_QUERY_PARAM);
    } catch (error) {
        sendXray('summer-promo-2026-failure');
        captureException(error, { issueKey: 'SummerPromo2026: query fetch failure' });
        logger.error(error);

        return false;
    }
};

export const useSummerPromo2026 = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isOverquota = useSelector(isCloudOrMailOrApiOverQuota);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isAnonymous = useSelector(UserSelectors.isAnonymous);
    const isQueryForceSummerPromo = checkSummerPromo2026ForceQuery();

    const isEnabled = (isAnonymous && summerPromo2026Anonym) || (!isAnonymous && summerPromo2026);

    return (isEnabled && !isPaidUser && !isOverquota && !isBizUser) || isQueryForceSummerPromo;
};
